import DataProvider from "@/utils/helpers/DataProvider";

import { ActionTree, Module } from "vuex";

import { State as RootState } from "@/store";
import { AssignSubGroupDTO } from "@/models/interfaces/users";

export const actions: ActionTree<{}, RootState> = {
  assignSubGroupToUser(_, dto: AssignSubGroupDTO) {
    return DataProvider.put(`users/${dto.userId}/subGroup`, {
      subGroupId: dto.subGroupId
    });
  }
};

const store: Module<{}, RootState> = {
  namespaced: true,
  actions
};

export default store;
